import { Outlet } from "react-router-dom"
import HelpPopover from "~/components/Admin/HelpPopover"
import Navbar from "~/components/Admin/Navigation/Navbar"

type Props = React.HTMLAttributes<HTMLDivElement>

export const AdminLayout: React.FC<Props> = () => {
  return (
    <>
      <Navbar />
      <HelpPopover />
      <Outlet />
    </>
  )
}
